module.exports = __webpack_public_path__ + "static/media/logo_simple.340787ab.svg";